'use strict';
import * as tools from './tools.js';

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core');
window.bootstrap = require('bootstrap');

import lazyframe from "lazyframe";
lazyframe(".lazyframe", {
    autoplay: true,
});

import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiper = new Swiper('.swiper__full', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    },
    on: {
        init: function () {
            let headerHeight = document.querySelector('header').offsetHeight;
            this.el.style.height = (innerHeight - headerHeight) + 'px';
            tools.pauseSliderVideos(this);
            tools.playSliderVideos(this);
        },
        transitionStart: function(){
            tools.pauseSliderVideos(this);
        },
        transitionEnd: function(){
            tools.playSliderVideos(this);
        },
    },
});

const swiperJornada = new Swiper('.swiper__jornada', {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const swiperHomeProductos  = new Swiper('.swiper__home_productos', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints : {
        600: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30
        },
    },
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const swiperHomeSectores  = new Swiper('.swiper__home_sectores', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints : {
      768: {
          slidesPerView: 2,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 3,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

const swiperHomeServicios  = new Swiper('.swiper__home_servicios', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints : {
      600: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      768: {
          slidesPerView: 3,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 4,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

const swiperHomeNoticias  = new Swiper('.swiper__home_noticias', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints : {
      768: {
          slidesPerView: 2,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 3,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});
 
$(window).scroll(function(){
  if ($(this).scrollTop() > 50) {
     $('header').addClass('fixed');
  } else {
     $('header').removeClass('fixed');
  }
});

$(document).ready(function () {
  //initialize swiper when document ready  
  var mySwiper = new Swiper ('.swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    mousewheelControl: true,
    keyboardControl: true,
  })        
});

let formFooterHome = document.querySelector('.form-footer-home');
if(formFooterHome !== null) {
    let ratioJourneys = formFooterHome.querySelectorAll('.ratio-journey'),
        inputHiddenJornada = formFooterHome.querySelector('[name="jornada"]'),
        ratioAmbas = formFooterHome.querySelector('.ratio-ambas');
    if(ratioJourneys !== null) {
        ratioJourneys.forEach((ele) => {
            ele.addEventListener('click',() => {
                if(ele.checked) {
                    inputHiddenJornada.value = ele.dataset.journey;
                    ratioAmbas.checked = false;
                }
            })
        })
    }
    if(ratioAmbas !== null) {
        ratioAmbas.addEventListener('click',() => {
            if(ratioAmbas.checked) {
                inputHiddenJornada.value = '';
                if(ratioJourneys !== null) {
                    ratioJourneys.forEach((ele) => {
                        ele.checked = false;
                    })
                }
            }
        })
    }
}